import React from "react";
import { useSelector } from "react-redux";
import SearchUserForm from "../../components/SearchUserForm/SearchUserForm";
import { getEmployeeContacts, getEmployeesSuggestion } from "../../store/actions/employee.actions";
import "./SearchEmployeeContact.scss";

const SearchEmployeeContact = () => {
  const { pagination, suggestionLoading } = useSelector(state => state.employee);

  return (
    <div className="employee-search">
      <SearchUserForm
        pagination={pagination}
        loading={suggestionLoading}
        getList={getEmployeeContacts}
        getSuggestions={getEmployeesSuggestion}
        filterCriteria={{ type: "employee" }}
      />
    </div>
  );
};

export default SearchEmployeeContact;
